import { apiService } from './api';
import { ApiResponse } from '../types';

export interface Activity {
  id: string;
  type: string;
  description: string;
  timestamp: string;
  metadata: {
    assessmentId?: number;
    clientId?: number;
    clientName?: string;
    userId?: number;
    userName?: string;
    status?: string;
    actionTaken?: string;
    activityType?: string;
    questionId?: number;
    questionLabel?: string;
    responseId?: number;
    updatedFields?: string[];
    goalsCount?: number;
    endpoint?: string;
    method?: string;
    [key: string]: unknown;
  };
}

export const activityService = {
  async getRecentActivities(limit = 10): Promise<Activity[]> {
    const normalizedLimit = Number.isFinite(limit) ? Math.floor(limit) : 10;
    const safeLimit = Math.min(Math.max(normalizedLimit, 1), 100);

    const response = await apiService.get<ApiResponse<{ activities: Activity[] }>>(
      `/activity/recent?limit=${safeLimit}`
    );

    if (response.data?.activities) {
      return response.data.activities;
    }
    return [];
  },
};
